import { useEffect, useState } from 'react'

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

/**
 * Invite d'installation de la PWA.
 *
 * Enjeu reel, pas confort : sur iOS, le Web Push n'existe QUE si la PWA est installee sur
 * l'ecran d'accueil (iOS 16.4+, spec 5.4). Sans installation, ces utilisateurs n'ont plus
 * que l'e-mail — dont la deliverabilite est justement le risque numero un du projet.
 *
 * iOS n'emet jamais `beforeinstallprompt` : l'invite explicite du parcours d'onboarding
 * (« Partager, puis Sur l'ecran d'accueil ») reste a construire, elle releve de L1.
 */
export function usePWAInstall() {
  const [evenement, setEvenement] = useState<BeforeInstallPromptEvent | null>(null)

  useEffect(() => {
    const capturer = (e: Event) => {
      e.preventDefault()
      setEvenement(e as BeforeInstallPromptEvent)
    }

    window.addEventListener('beforeinstallprompt', capturer)
    return () => window.removeEventListener('beforeinstallprompt', capturer)
  }, [])

  const installer = async () => {
    if (!evenement) return
    await evenement.prompt()
    await evenement.userChoice
    setEvenement(null)
  }

  return { installable: evenement !== null, installer }
}
